export const formatProductToRouteParams = (product: { id: any, title: string }, state = 'NEW') => {
    if (!product) return '';
    return `${String(product.id)}-${product.title.toLowerCase().split(' ').join('-')}?state=${state}`;
}